<template>
<div id="app">
	<router-view></router-view>
</div>
</template>

<script>
export default {
	name: 'app',
	data() {
		return {
			barcode:'',
			timeout:false,
			start:0
		}
	},
	methods:{
		barcodeEvent(){
			// document.addEventListener('keydown', (e) => {
			// 	if (this.barcode.length && this.timeout){
			// 		clearTimeout(this.timeout);
			// 		this.timeout=false;
			// 	}
			// 	if (this.barcode.length == 20 || (e.which == 13 && this.barcode.length > 5)){
			// 		e.preventDefault();
			// 		e.stopPropagation();
			// 		this.barcodeScanned(this.barcode);
			// 		this.barcode = '';
			// 		return;
			// 	}
			// 	else{
			// 		this.barcode+=e.key;
			// 		this.timeout = setTimeout(() =>{
			// 			this.barcode='';
			// 		},50);
			// 	}
				
			// }, false);
		},
		barcodeScanned(code){
			let auction_id = parseInt(code.substr(0,4));
			let item_id = parseInt(code.substr(4,6));
			let seller_id = parseInt(code.substr(10,6));
			let order_nr = parseInt(code.substr(16,6));
			window.location.href = `/auction/${auction_id}/items/${item_id}`;
			//this.$router.push(`/auction/${auction_id}/items/${item_id}`);
			//console.log(auction_id, item_id, seller_id, order_nr);
		}
	},
	mounted(){
		this.barcodeEvent();
	}
};
</script>



// WEBPACK FOOTER //
// App.vue?d4da4030